module.exports = __webpack_public_path__ + "img/image_titularidad.66fb9c59.svg";